export default __webpack_public_path__ + "static/media/iconocuatro.2d22472e.svg";